import React, { memo, useState } from 'react';
import useMount from '../../utils/hooks/use-mount';

/**
 * 显示 footer, 避免闪烁
 * @returns {JSX.Element}
 * @constructor
 */
const DisplayPublicFooter = () => {
  const [hasMount, setHasMount] = useState(false);
  useMount(() => {
    setHasMount(true);
  });
  if (!hasMount) {
    return null;
  }
  return <style>{'.public_footer { display: block!important }'}</style>;
};

export default memo(DisplayPublicFooter);
